import React, { useMemo } from 'react';
import { Activity } from '../../store/Activities.store';
import {
  Container,
  ActivityCard,
  ActivityTitle,
  ActivityDistance,
} from './styles';

interface Props {
  activities: Activity[];
}

export default function VirtualRaceActivitySummary({ activities }: Props) {
  const sortedActivities = useMemo(() => {
    if (!activities || activities.length === 0) return [];
    return [...activities].sort((a, b) => (b.distance || 0) - (a.distance || 0));
  }, [activities]);

  const formatDistance = (distance: number) => {
    const hasDecimal = distance % 1 !== 0;
    return hasDecimal ? `${distance.toFixed(1)} KM` : `${Math.floor(distance)} KM`;
  };

  if (sortedActivities.length === 0) return null;

  return (
    <Container>
      {sortedActivities.map((activity) => (
        <ActivityCard key={activity.id}>
          <ActivityTitle>{activity.title || 'Corrida'}</ActivityTitle>
          <ActivityDistance>{formatDistance(activity.distance || 0)}</ActivityDistance>
        </ActivityCard>
      ))}
    </Container>
  );
}
